import * as React from 'react';
import _ from 'lodash';
import { WithTranslation, withTranslation } from 'react-i18next';

import * as api from '../../api';

import { getOptionsFromRecord } from '../utils';
import { parseValue } from 'common/dist/utils/types';
import { MultiEnum } from './MultiEnum';
import Enum from './Enum';

interface Props extends WithTranslation {
  previsitWrittenLanguageOptions: api.Language.Language[];
  onChange: (value: string) => Promise<void>;
  useAlternateEnum: boolean;
  value: string;
  multi?: boolean;
}

interface State {}

class WrittenLanguagesInput extends React.Component<Props, State> {
  render() {
    const {
      previsitWrittenLanguageOptions,
      value,
      multi,
      useAlternateEnum,
      onChange,
      t,
    } = this.props;

    const values: string[] = parseValue(value) || [];

    const displayOptions = getOptionsFromRecord(
      _.pick(api.Language.languageMap, previsitWrittenLanguageOptions),
      t,
    );

    if (!multi) {
      return (
        <Enum
          value={values[0]}
          options={displayOptions}
          useAlternateEnum={useAlternateEnum}
          onChange={async (option) => {
            const formattedOption = JSON.stringify(option ? [option] : []);
            this.props.onChange(formattedOption);
          }}
        />
      );
    }

    return (
      <MultiEnum
        values={values}
        options={displayOptions}
        onChange={async (options) => onChange(options)}
      />
    );
  }
}

export default withTranslation()(WrittenLanguagesInput);
